<template>
  <div class="mlayout">
    <div class="mlsnav">
      <div
        class="mlbutton"
        @click="selectlayout(0)"
        :style="{
          background: value == 0 ? 'rgba(25, 97, 172, 1)' : '',
          color: value == 0 ? '#fff' : 'rgba(6, 25, 45, 0.7)',
        }"
      >
        国内布局
      </div>
      <div
        class="mlbutton"
        @click="selectlayout(1)"
        :style="{
          background: value == 1 ? 'rgba(25, 97, 172, 1)' : '',
          color: value == 1 ? '#fff' : 'rgba(6, 25, 45, 0.7)',
        }"
      >
        海外布局
      </div>
    </div>
    <div v-if="value == 0" class="inlayout">
      <mlayoutin @mapclick="mapclick" />
      <div class="plist" v-if="plist == true">
        <div class="plisttitle">{{ sfname }}省项目明细</div>
        <div class="plists" v-for="(i, j) in sfdata">{{ i.name }}</div>
      </div>
    </div>
    <div v-if="value == 1" class="inlayout">
      <mlayoutout />
    </div>
  </div>
</template>

<script>
import mlayoutin from "./mlayoutin.vue";
import mlayoutout from "./mlayoutout.vue";
export default {
  components: {
    mlayoutin,
    mlayoutout,
  },
  data() {
    return {
      value: 0,
      plist: false,
      sfname: "",
      sfdata: [],
    };
  },
  methods: {
    mapclick(e) {
      this.plist = true;
      this.sfname = e.sf;
      this.sfdata = e.data;
    },
    selectlayout(e) {
      this.value = e;
    },
  },
};
</script>

<style lang="less" scoped>
.mlayout {
  .inlayout {
    .plist {
      .plists {
        width: 100%;
        min-height: 9.07vw;
        border-bottom: 1px solid rgba(216, 216, 216, 0.7);
        padding-left: 2.67vw;
        line-height: 9.07vw;
        color: rgba(6, 25, 45, 0.6);
        font-size: 14px;
      }
      .plisttitle {
        width: 100%;
        height: 9.07vw;
        background: rgba(242, 243, 247, 1);
        padding: 0 2.67vw;
        line-height: 9.07vw;
        font-size: 14px;
        color: rgba(6, 25, 45, 0.8);
      }
      margin-top: 5.33vw;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid rgba(222, 223, 230, 0.7);
      border-bottom: 0px;
    }
    width: 100%;
  }
  .mlsnav {
    .mlbutton {
      width: 18.67vw;
      height: 8.53vw;
      line-height: 8.53vw;
      text-align: center;
      border-radius: 4px;
    }
    width: 100%;
    height: 8.53vw;
    display: flex;
    align-items: center;
    gap: 2.67vw;
    margin-bottom: 3.2vw;
  }
  width: 100%;
  padding: 3.2vw;
  padding-bottom: 8.53vw;
  background: #fff;
}
</style>
